import axios from 'axios';
import store from '@/store/index';
import router from '@/router/index';

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROUTE,
  headers: {
    common: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
});

export const surveyApi = axios.create({
  baseURL: process.env.VUE_APP_SURVEY_API_ROUTE,
  headers: {
    common: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  },
});

export const setAuthHeader = (token) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  surveyApi.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const resetAuthHeader = () => {
  delete api.defaults.headers.common.Authorization;
  delete surveyApi.defaults.headers.common.Authorization;
};

api.interceptors.request.use(
  async (config) => {
    try {
      await store.dispatch('updateToken');
    } catch (error) {
      await store.dispatch('userLogout');
    }

    return config;
  },
  (error) => {
    this.$router.push({ name: 'Home' });
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const currentRoute = router.currentRoute.name;

      //if status is 401 the user is redirected to login and can proceed with ticket creation flow
      if (['ManifestationType', 'SolicitationType'].includes(currentRoute)) {
        await store.dispatch('initKeycloak');

        return;
      }

      //fallback: stops user from trying to send a ticket with invalid auth
      if (['ManifestationFinish', 'SolicitationFinish'].includes(currentRoute)) {
        store.dispatch('setUnauthorizedError', true);

        return;
      }

      await store.dispatch('userLogout');
    }

    return Promise.reject(error);
  },
);